import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import { loadSocialWallPostAction } from '../../reducers/socialwall.reducers';
import { onLoadCourse } from '../../reducers/course.reducers';
import { onLoadAllTestQuestions } from '../../reducers/test.reducers';
import ContentPicker from './content-picker';

const mapDispatchToProps = dispatch => ({
  loadPost: id => dispatch(loadSocialWallPostAction(id)),
  loadCourseCards: course => dispatch(onLoadCourse(course)),
  loadQuestions: test => dispatch(onLoadAllTestQuestions(test)),
});

const mapStateToProps = state => ({
  post: state.socialwall.currentPost,
  testGroups: state.tests.tests,
  questions: state.tests.questions,
  courseGroups: state.courses.courses,
  isLoadingCards: state.courses.isLoadingCards,
  isLoadingQuestions: state.tests.isLoadingQuestions,
  cards: state.courses.currentCards,
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPicker);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/content-picker.container.js